export const SCHEDULE_APPOINTMENT_PARAM_NAME = 'step';

export const SCHEDULE_APPOINTMENT_STEP_SELECT_PRODUCT = 'select-product';

export const SCHEDULE_APPOINTMENT_STEP_SCHEDULE_EXPERIENCE = 'schedule-experience';

export const SCHEDULE_APPOINTMENT_STEP_PERSONALIZE_EXPERIENCE = 'personalize-experience';

export const SCHEDULE_APPOINTMENT_STEP_CONTACT_FORM = 'contact-form';
